import { inject, injectable } from 'inversify'
import { Vector2 } from 'three'
import { TYPES } from '@/plugins/cad/module/container/types'
import type { EngineContext } from '@/runtime/EngineContext'

const CAD_POINT_CLOUD_PICK_WINDOW_SIZE = 5

/** 点云吸附辅助工具 */
@injectable()
export class PointCloudHelper {
  @inject(TYPES.EngineContext) private readonly ctx!: EngineContext

  private enabled: boolean = false

  /**
   * 查询点云吸附开关状态。
   *
   * @returns 是否已启用
   */
  public isEnabled() {
    return this.enabled
  }

  /**
   * 开关点云吸附。
   *
   * @param val - 是否启用
   */
  public setEnabled(val: boolean) {
    this.enabled = val
  }

  /**
   * 获取点云命中位置。
   *
   * @param offsetX - 指针相对画布的 X 屏幕坐标
   * @param offsetY - 指针相对画布的 Y 屏幕坐标
   * @returns 命中点的世界坐标与吸附标记；未命中或未启用时返回 null
   */
  public getHitPosition(
    offsetX: number,
    offsetY: number
  ): { point: { x: number; y: number; z: number }; isSnappingPointCloud: boolean } | null {
    if (!this.enabled) {
      return null
    }

    if (!this.ctx.hasService('PickingService')) {
      return null
    }

    const pickingService = this.ctx.getService('PickingService')
    const screen = new Vector2(offsetX, offsetY)
    const camera = this.ctx.getService('ViewportCamera').getActiveCamera()
    const results = pickingService.pickAtScreen(screen, camera, {
      kinds: ['pointCloud'],
      windowSize: CAD_POINT_CLOUD_PICK_WINDOW_SIZE,
    })

    if (results.length > 0) {
      const hit = results[0]
      return {
        point: { x: hit.point.x, y: hit.point.y, z: hit.point.z },
        isSnappingPointCloud: true,
      }
    }
    return null
  }
}
